module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-3",
      "lang": "en-US"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I was in the office after breakfast the next morning when Lily rang. “I got hold of Sofia, and I told her I wanted to get the key to Maureen’s duplex. She gave me her address and said I could come over anytime. But she felt that she should be present when we go to Maureen’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Protecting her employer’s property, no doubt.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Perhaps. Like us, she seems to be worried. She told me Maureen had never left town before without telling her where she was going and when she’d return.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I took a sip of coffee before answering. “Did you tell her I would be tagging along?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, and she said that she had no objection.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Glad to hear it. Did you find out her last name?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Jurek. It sounds like it might be Czech. She does have an accent, although her English is really quite good,” Lily said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“More likely she’s Polish,” I said. “She is probably one of the many Europeans who have come over here in the couple of years since the end of the war. I will pick you up in front of your building in … say, forty minutes, how does that sound?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well … yes, okay,” Lily replied. She still sounded uncomfortable about our undertaking. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I left a note on Wolfe’s desk, telling him I would be out most of the morning. We had no pressing cases, so he had no urgent need for me at the moment, as I had already typed up his correspondence from yesterday and left it on his desk for signing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In fact, life in the old brownstone on West Thirty-Fifth Street near the Hudson had been downright serene recently. The bank balance was in okay shape, allowing Wolfe to indulge himself as usual with his ten thousand orchids on the roof, which he tends with his orchid nurse, Theodore Horstmann, and his books, of which he is reading three at any given time. And then, of course, there are the superb meals prepared by our live-in Fritz Brenner, which doubtless contribute to Wolfe’s seventh-of-a-ton bulk.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I got the convertible from Curran Motors, a block from the brownstone, where we have garaged our cars for years. I kept the top up as a buffer against the late March winds and drove north to Lily’s. She was waiting for me under the canopy of her building, wearing a beret and a scarf, with the collar of her raincoat tight around her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hope I didn’t keep you waiting long,” I said as she slid gracefully into the car and gave me a kiss on the cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, your timing was perfect. I stepped outside just thirty seconds ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We drove north up Broadway to where the numbered cross streets jumped into the triple digits. For those visitors to New York who confine themselves to Midtown and its theaters and stores and hotels, they likely think of Manhattan as basically flat. One notable exception is Morningside Heights up near the north end of the island, home to Columbia University, St. John the Divine Cathedral, Grant’s Tomb, and … hills. Okay, these hills may not be impressive to someone from San Francisco, but they are rocky and with sometimes steep drop-offs, and the topography makes for some interesting vistas.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There was nothing particularly interesting, however, about the blocks just west of Broadway where Sofia Jurek lived. The area was lined with bland four- and five-story brick walk-ups. At Lily’s direction, I pulled up in front of one of these and we entered the bare street-level foyer, one wall of which was lined with mailboxes and buzzers. Lily pushed the button with "), _c('span', {
    staticClass: "ORIM-ital CharOverride-1"
  }, [_vm._v("JUREK")]), _vm._v(" on the card under it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes?” came the static-filled voice. When Lily gave her name, the voice said, “Three seventeen.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We trudged up the heavily worn stairways to the third floor. Down a dimly lit corridor, a head could be seen peering out into the hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hello, Sofia,” Lily said to the petite, dark-haired woman in the doorway. “It’s nice to see you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It is very nice to see you also, Miss Rowan,” Sofia replied formally, looking at me with a questioning expression.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“This is my friend, Archie Goodwin,” Lily explained as we walked into the living room that seemed too filled with furniture, but was nonetheless neat. “He will be going with us to Miss Carr’s home. I will ask again as I did when we talked on the telephone earlier today: Do you have any idea where Miss Carr might have gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sofia shook her head vigorously. “I do not, not at all. Please sit down, both of you. Would you like to have some coffee? I have a pot made.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I was about to say no thanks, but Lily had other ideas. “That would be very nice,” she said as our hostess hustled out of the room, presumably in the direction of the kitchen. “I have a few other questions to ask her,” Lily said in a voice just above a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s usually my line,” I semi-whispered in reply.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sometimes a woman is more comfortable answering questions from another woman. I hope you don’t take offense.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“None taken,” I replied as Sofia came in with steaming cups of coffee on a tray.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Thank you so much,” Lily said as we sat, she and I on a sofa with plaid slipcovers and our hostess in a chair facing us. “I seem to remember you telling me once that your husband works for a scrap metal company over in Brooklyn.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That is right, Miss Rowan. He is there now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How long have you been married?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sofia rolled her eyes, as if thinking. “Almost six years, yes. I was what you call a ‘war bride,’” she said, cheeks flushing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That is very romantic,” Lily said with a smile. “So, your husband is American?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Stan fought in your army, yes, Miss Rowan. We met in England just after the war was ending. I was one of many from Poland who were moved to London when the fighting still went on. We were married there. My name was Kaminski then, a very Polish name. But I am a Jurek now, which is much shorter. And that is nicer, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you have children?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not yet,” Sofia said. “Stan felt we should get settled in and save some money first. But we do want to have a family.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily nodded. “Let me ask you about Miss Carr,” she said. “Before she … left, did she appear to be worried or upset to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, the last time I saw her, she did not seem to be at all unhappy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“When was that?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I think two weeks ago last Wednesday. I go to Miss Carr’s three times each week, sometimes more if she needs me to help when she has guests.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“On that day, did she tell you she would be taking a trip?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, she said nothing about any trip to me, Miss Rowan, as I told you before.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And what happened the next time you went to her apartment?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That was a Friday. Miss Carr was not there.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Were you surprised?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, she very often was not at home when I came in the morning. She is very busy, with many meetings, breakfasts, lunches.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, I know, and I am at some of those very same meetings,” Lily said. “When did you become worried about her?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I think it was on Monday. Again, she was not home, and there was no message for me. She often left me, what do you call them … instructions?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Did you make a telephone call to anyone asking about Miss Carr?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Again, Sofia shook her head. “Was I wrong to not tell someone?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, no, not at all,” Lily assured her, reaching over and lightly squeezing the young woman’s arm. “Thank you so much for the coffee. I think we should go down to Miss Carr’s now. Archie, be a dear and carry the cups and pot back to the kitchen.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh no, no, I should do that, Miss Rowan.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mr. Goodwin is perfectly capable. I don’t want to see him spoiled,” Lily said with a laugh. Knowing my role, I put the cups, spoons, and pot on the tray and headed for the small and neat kitchen with Sofia at my side.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You can just put everything down next to the sink, Mr. Goodwin,” she said, going to the wall next to a calendar, taking a key off one of a series of hooks, and slipping it into her pocket. We returned to the living room, where Lily was putting her beret on. “You make very good coffee, Sofia,” she said. “And now we all are off.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sofia nodded, her expression somber. It was obvious she had mixed emotions about our venture. “I will get my raincoat,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You make a good detective,” I whispered to Lily. “Ask a few personal questions first to make the interrogee relax, and then start in with the more probing ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I hardly think I asked anything that was very probing,” Lily replied. “By the way, is interrogee really a word?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“All I can say is Nero Wolfe has used it in the past, so I rest my case. Now, let’s go.” As we left the apartment, Sofia’s face still registered uncertainty.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The drive southeast found us in front of a brick-and-stone Park Avenue tower with a modest dark blue canopy in front. Any wealth this building contained, and there had to be plenty of it, was not reflected in its subdued exterior. As someone once said, the really rich have no need to flaunt it. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I parked in defiance of the posted regulations and we greeted the uniformed doorman, whose face had Ireland written all over it. His coat had the word "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Seamus")]), _vm._v(" stitched on the front, confirming his roots. “We are dear friends of Miss Carr,” Lily told him with the same dazzling smile that first captivated me years ago. “And you of course know Mrs. Jurek.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, although I refer to her as Sofia,” Seamus said, touching the brim of his hat, winking at the young woman, and returning Lily’s smile. “I have not seen Miss Carr for some time,” he said, turning serious. “Has she been away?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, and we promised that we would look in on her place,” Lily improvised, showing him the key. “I am Lily Rowan, and this is my friend Mr. Goodwin.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I am very good with faces, and I of course recognized you, Miss Rowan, from the many times that you have been here to see Miss Carr. All of you, please go right on up.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The building had no hall man, so we breezed through the vaulted and chandeliered lobby to the automatic elevators.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Needless to say, Maureen occupies the penthouse,” Lily said to me as the three of us were smoothly carried skyward. The doors opened at the eleventh floor, and we found ourselves in a circular entrance hall, done in the "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("moderne")]), _vm._v(" style, with indirect lighting and a black-and-white-checked tile floor that gleamed. Through an archway, I could see what probably was a living room, also high-ceilinged, although in a layout like this, it probably carried a more impressive name, maybe "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("salon")]), _vm._v(" or "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("drawing room")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Also, needless to say, Maureen occupies all of this floor and the one above it. And that puts her at the very top,” Lily informed me, gesturing toward a stairway that wound upward.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“To use your phrase, ‘needless to say.’ And similar to you in your own nearby aerie, I suppose she has a terrace as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She does indeed. First, it’s ‘interrogee’ and now ‘aerie.’ It seems to me that you’re showing off.” I know Lily well enough to tell when she is nervous, and when that happens, she often covers her unease with light banter, as if she doesn’t have a care in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Turning to Sofia, Lily said, “Where do you think we should look first? You know this apartment far better than I do. And Mr. Goodwin has of course never been here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The young woman had apparently overcome her reluctance at this excursion, and she seemed ready to take orders. “Wherever you suggest,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We should start with Miss Carr’s bedroom. What do you think?” I addressed the question to Sofia, trying to give her some say over the proceedings.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She smiled shyly. “Yes … I … yes, if you think so.” She led us down a hall with several doors and opened one at the end.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And what a boudoir it was that greeted us. A corner room twice the size of Wolfe’s office had large windows that looked out upon the sprawl of Central Park to the north.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The scene within the room was impressive as well. The carpeting and furnishings were a dazzling white, and the canopied bed, with a white spread, of course, looked large enough to accommodate several people. “All that’s needed here is a couple of white Corgi puppies to complete the effect,” I observed. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Now there is no need to be acerbic. This very room, and indeed the whole apartment, has been featured in two of the toniest home decor magazines,” Lily said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I stand chagrined. By the way, you are pretty snappy with the vocabulary yourself, as in ‘acerbic.’”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I am only trying to keep pace with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Noted. Sofia, do things in here appear to be in order to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She nodded, looking around. “Nothing seems to be out of place, Mr. Goodwin.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You may want to check some of the other rooms to see if you find anything that doesn’t look as it should,” I suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Another nod, and she went out, leaving the two of us. “I get the idea that you wanted to get rid of her,” Lily said, narrowing her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Was I that obvious?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, I suppose not, at least to anyone but me. I figure that you want to have free rein to go through Lily’s private quarters, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You have found me out. I assume you’ve been in this part of Miss Carr’s residence.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, but only a few times.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Does she have some sort of an office?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, she does, right through here,” Lily said, opening a door on the far side of the bedroom. Referring to the room we entered as an office would be doing it an injustice. As spacious as the bedroom, it contained among other items a dark wood rolltop desk with pigeonholes that looked like it belonged to a small-town banker. Next to the desk was a wooden, three-drawer filing cabinet of the same vintage as the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“These certainly don’t seem to go with the rest of the decor I’ve seen so far,” I said to Lily, gesturing to the desk and cabinet.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Maureen told me once that these belonged to her father, the Pennsylvania steel man, and she keeps them to honor his memory, much like I have a gallery of photos of my own father from when he was building all those sewers that run under Manhattan.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Makes sense. Now if you don’t have any objection, I’m going through the desk and the files.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have no objection whatever. Do you need some help?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, let’s take a look at what we find together,” I said as I pulled open the center desk drawer, which contained only a few recent press clippings from New York papers in a manila folder. I showed them to Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have several of these, too,” she said. “They are all items, mostly in the newspapers’ society pages, about events held by some of the organizations we both are involved in. Maureen and I, along with the others in our women’s circle, love to see publicity, not as much for our own egos but because we have found that these stories about our events end up drawing in new volunteers—and financial gifts, as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Admirable,” I said, checking the pigeonholes but finding nothing in them other than a couple of playbills from recent Broadway shows. “Tell me about Maureen’s social life,” I asked Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Since her divorce from Corcoran, she has gone out with probably at least a half-dozen men.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I am not surprised. Anyone in particular she’s serious about?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m not sure. Maureen doesn’t talk a lot about the men she sees. You’ve probably run into one or more of them in gatherings at my place.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Now that you mention it, I have. I ran into an ad man there named Eric one night. Very extroverted, hardly surprising for someone in advertising. It’s easy to see how he could make a hit with the clients that the agency is trying to land.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, I’ve met him several times,” Lily said, “tall, well dressed, and full of smiles, last name Mason, and he wears a tuxedo well. I remember running into them at the opera. I’m not sure whether he and Maureen are still an item, although they very well might be.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“After she got divorced, she returned to using her maiden name,” I observed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Actually, Maureen never changed her last name. She is what you would call a modern—and independent—woman in that respect, meaning that she is not about to take a man’s name just because she has married him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hmm. What is your opinion on that subject?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I applaud the lady’s stance.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Good to know.… Well, there doesn’t seem to be anything of help for us in the desk, so I’m going to tackle the filing cabinet,” I said, pulling open the top drawer and taking out a batch of neatly labeled manila folders. I spread them out on a small table on the other side of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Okay, let’s find out what we can,” I told Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I really feel strange about this, as though I am somehow a trespasser.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can understand that, but what you call ‘trespassing’ may be the only way we have right now of learning what has happened to a very good friend of yours.” She nodded her agreement, and we began wading through the file folders. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3041e498","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MissingHeiress3.vue
// module id = 81
// module chunks = 0